import { defineStore } from 'pinia';
import axios from 'axios';
import api from '@/venit/components/cortona-venit/services/api';

interface UserResponse {
  // Define based on your actual API response
  [key: string]: any;
}

interface AccountState {
  logon: boolean;
  userIdentity: any | null;
  authenticated: boolean;
  ribbonOnProfiles: string;
  activeProfiles: string;
  accountSwitched: boolean;
  realUserName: string | null;
  user: any | null;
}

export const useAccountStore = defineStore('account', {
  state: (): AccountState => ({
    logon: false,
    userIdentity: null,
    authenticated: false,
    ribbonOnProfiles: '',
    activeProfiles: '',
    accountSwitched: false,
    realUserName: null,
    user: null,
  }),

  getters: {
    account: (state) => state.userIdentity,
    currentUser: (state) => state.user,
  },

  actions: {
    authenticate() {
      this.logon = true;
    },

    setAuthenticated(identity: { user: any; switched: boolean; realUserName: string | null }) {
      this.userIdentity = identity.user;
      this.authenticated = true;
      this.accountSwitched = identity.switched;
      this.realUserName = identity.realUserName;
      this.logon = false;
    },

    logout() {
      this.userIdentity = null;
      this.authenticated = false;
      this.logon = false;
      this.accountSwitched = false;
      this.realUserName = null;
    },

    setActiveProfiles(profile: string) {
      this.activeProfiles = profile;
    },

    setRibbonOnProfiles(ribbon: string) {
      this.ribbonOnProfiles = ribbon;
    },

    setCurrentUser(userData: any) {
      this.user = userData;
    },

    async loadUser() {
      const currentUserResponse = await axios.get<UserResponse>('/api/v1/users/current');
      this.setCurrentUser(currentUserResponse.data);
    },

    async login(credentials: { email: string; password: string; rememberMe: boolean }): Promise<boolean> {
      try {
        const response = await api.login(credentials.email, credentials.password, credentials.rememberMe);
        if (response && response.accessToken) {
          localStorage.setItem('accessToken', response.accessToken);
          if (response.refreshToken) {
            localStorage.setItem('refreshToken', response.refreshToken);
          }
          this.logon = true;
          await this.loadUser();
          return true;
        }
        return false;
      } catch (error) {
        console.error('Login failed:', error);
        return false;
      }
    },
  },
});
